export default {
      id: "return-usage",
      viewBox: "0 0 33 32",
      url: __webpack_public_path__ + "sprite.svg#return",
      toString: function () {
        return this.url;
      }
    }